var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("figure", [
    _c("img", {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy",
          value: _vm.imageSrc,
          expression: "imageSrc"
        }
      ],
      attrs: { alt: _vm.appName }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-010d35e9", { render: render, staticRenderFns: staticRenderFns })
  }
}